import moment from 'moment';

import {
  DAILY_REPORTS_SET,
  DAILY_REPORTS_UPDATE,
  SET_CONTRIBUTORS,
  SET_CURRENT_DAILY_REPORT,
  LOAD_PRESET_TASKS,
  ADD_DAILY_REPORT_SUCCESS,
  INITIALIZE_TRADE_FORM,
  UPDATE_TRADE_FORM,
  CHANGE_AMOUNT_OF_TECHNICIANS,
  HANDLE_WORKED_FORM,
  HANDLE_WORKED_TO,
  HANDLE_HOURS_AMOUNT,
  HANDLE_HOURS_AMOUNT_MORE_INFO,
  HANDLE_ATTRIBUTE_CHANGE,
  CLEAR_FORM,
  SET_DAILY_REPORT_LOG_PDF,
  SET_REPORTS_IDS,
  DELETE_DAILY_REPORT,
  SET_ACTIVE_ENTRIES_ID,
  SET_REPORT_PDF,
  SET_REPORT_DATE,
  SET_REPORT_EXTRA_INPUTS,
  SET_REPORT_EXTRA_INPUT,
  SET_REPORT_OPEN_ITEM,
  SET_REPORT_OPEN_ITEM_VALUE,
  SET_GENERAL_CONTACTOR_NAME,
  SET_SUPERVISOR_TASKS,
  SET_MEMBERS,
  SET_DELETED_MEMBERS,
  SET_GCX_IMAGES,
  SET_GCX_DELETED_IMAGES,
  SUB_DAILY_REPORTS_COUNT_SUCCESS,
  SUB_DAILY_REPORTS_COUNT_INIT,
  HANDLE_ATTRIBUTE_CHANGE_FOR_SUB,
  HANDLE_DATE_MORE_INFO,
  HANDLE_ATTRIBUTE_CHANGE_FOR_SUB_MORE_ACTION,
  ADDED_DELETED_TECHNICIANS,
  FIELD_WORK_ORDERS_SET,
  FIELD_WORK_ORDER_SET,
  FIELD_WORK_ORDER_FORM_INIT,
  FIELD_WORK_ORDER_FORM_ATTRIBUTE_SET,
  UPDATE_FIELD_WORK_ORDER_SUCCESS,
  DUPLICATE_DAILY_REPORT_SUCCESS,
} from 'components/admin/projects/details/project-daily-report-log/store/action-types';

const initialState = {
  dailyReports: [],
  fieldWorkOrders: [],
  currentDailyReport: null,
  currentDailyReportIds: null,
  currentFieldWorkOrder: null,
  contributors: [],
  presetTasks: {},
  contributorsForm: {},
  dailyReportLogPdf: null,
  activeEntryId: null,
  reportLogPdf: null,
  subDailyReportsCount: null,
  reportDate: moment().format('YYYY-MM-DD'),
  reportExtraInputs: {},
  reportOpenItem: {},
  generalContactor: null,
  members: [],
  deletedMembers: [],
  supervisorTasks: [],
  gcImages: [],
  gcDeletedImages: [],
  fieldWorkOrderForm: {},
};

export default function projectDailyReportLogDataReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case DAILY_REPORTS_SET:
      return {
        ...state,
        dailyReports: action.payload,
      };

    case FIELD_WORK_ORDERS_SET:
      return {
        ...state,
        fieldWorkOrders: action.payload,
      };

    case FIELD_WORK_ORDER_SET:
      return {
        ...state,
        currentFieldWorkOrder: action.payload,
      };

    case SET_REPORTS_IDS:
      return {
        ...state,
        currentDailyReportIds: action.payload,
      };

    case SET_ACTIVE_ENTRIES_ID:
      return {
        ...state,
        activeEntryId: action.payload,
      };

    case DAILY_REPORTS_UPDATE:
      return {
        ...state,
        dailyReports: state.dailyReports.map((report) => {
          if (report.id === action.payload.id) {
            return action.payload;
          }
          return report;
        }),
      };

    case SET_CONTRIBUTORS:
      return {
        ...state,
        contributors: action.payload,
      };

    case SET_CURRENT_DAILY_REPORT:
      return {
        ...state,
        currentDailyReport: action.payload,
      };

    case LOAD_PRESET_TASKS:
      return {
        ...state,
        presetTasks: action.payload,
      };

    case ADD_DAILY_REPORT_SUCCESS:
      return {
        ...state,
        currentDailyReport: action.payload,
        dailyReports: [
          action.payload,
          ...state.dailyReports.filter(
            (report) => report.id !== action.payload.id
          ),
        ],
        currentDailyReportIds: action.payload.daily_report_entries
          .sort((report1, report2) => report1.id - report2.id)
          .map((report) => report.id),
      };

    case INITIALIZE_TRADE_FORM:
      return {
        ...state,
        contributorsForm: {
          ...state.contributorsForm,
          ...action.payload,
        },
      };

    case UPDATE_TRADE_FORM:
      return {
        ...state,
        contributorsForm: action.payload,
      };

    case CHANGE_AMOUNT_OF_TECHNICIANS:
      return {
        ...state,
        contributorsForm: {
          ...state.contributorsForm,
          [action.payload.contribId]: {
            ...state.contributorsForm[action.payload.contribId],
            technicians: action.payload.technicians,
          },
        },
      };

    case ADDED_DELETED_TECHNICIANS:
      return {
        ...state,
        contributorsForm: {
          ...state.contributorsForm,
          [action.payload.contribId]: {
            ...state.contributorsForm[action.payload.contribId],
            deletedTechnicians: [
              ...state.contributorsForm[action.payload.contribId]
                .deletedTechnicians,
              action.payload.technician,
            ],
          },
        },
      };

    case HANDLE_WORKED_FORM:
      let newTechnicians = [
        ...state.contributorsForm[action.payload.contribId].technicians,
      ];
      newTechnicians[action.payload.techId] = {
        ...state.contributorsForm[action.payload.contribId].technicians[
          action.payload.techId
        ],
        workedFrom: action.payload.value,
        hoursAmount: '',
      };
      return {
        ...state,
        contributorsForm: {
          ...state.contributorsForm,
          [action.payload.contribId]: {
            ...state.contributorsForm[action.payload.contribId],
            technicians: newTechnicians,
          },
        },
      };

    case HANDLE_WORKED_TO:
      let newTechniciansValues = [
        ...state.contributorsForm[action.payload.contribId].technicians,
      ];
      newTechniciansValues[action.payload.techId] = {
        ...state.contributorsForm[action.payload.contribId].technicians[
          action.payload.techId
        ],
        workedTo: action.payload.value,
        hoursAmount: '',
      };
      return {
        ...state,
        contributorsForm: {
          ...state.contributorsForm,
          [action.payload.contribId]: {
            ...state.contributorsForm[action.payload.contribId],
            technicians: newTechniciansValues,
          },
        },
      };

    case HANDLE_ATTRIBUTE_CHANGE_FOR_SUB:
      let newTechniciansValuesForSub = [
        ...state.contributorsForm[action.payload.contribId].technicians,
      ];
      let additionalInfo =
        newTechniciansValuesForSub[action.payload.techId].additionalInfo;
      if (action.payload.attribute === 'sub_technician' && additionalInfo) {
        additionalInfo = additionalInfo.map((info) => ({
          ...info,
          sub_technician_id: '',
          sub_technician: action.payload.value,
        }));
      }
      newTechniciansValuesForSub[action.payload.techId] = {
        ...state.contributorsForm[action.payload.contribId].technicians[
          action.payload.techId
        ],
        [action.payload.attribute]: action.payload.value,
        additionalInfo,
      };
      return {
        ...state,
        contributorsForm: {
          ...state.contributorsForm,
          [action.payload.contribId]: {
            ...state.contributorsForm[action.payload.contribId],
            technicians: newTechniciansValuesForSub,
          },
        },
      };

    case HANDLE_ATTRIBUTE_CHANGE_FOR_SUB_MORE_ACTION:
      let techniciansValuesForMoreInfoAttribute = [
        ...state.contributorsForm[action.payload.contribId].technicians,
      ];
      let additionalInfoValuesAttribute = [
        ...state.contributorsForm[action.payload.contribId].technicians[
          action.payload.techId
        ].additionalInfo,
      ];
      additionalInfoValuesAttribute[action.payload.infoIndex] = {
        ...additionalInfoValuesAttribute[action.payload.infoIndex],
        [action.payload.attribute]: action.payload.value,
      };

      techniciansValuesForMoreInfoAttribute[action.payload.techId] = {
        ...state.contributorsForm[action.payload.contribId].technicians[
          action.payload.techId
        ],
        additionalInfo: additionalInfoValuesAttribute,
      };
      return {
        ...state,
        contributorsForm: {
          ...state.contributorsForm,
          [action.payload.contribId]: {
            ...state.contributorsForm[action.payload.contribId],
            technicians: techniciansValuesForMoreInfoAttribute,
          },
        },
      };

    case HANDLE_HOURS_AMOUNT:
      let techniciansValues = [
        ...state.contributorsForm[action.payload.contribId].technicians,
      ];
      techniciansValues[action.payload.techId] = {
        ...state.contributorsForm[action.payload.contribId].technicians[
          action.payload.techId
        ],
        workedTo: '',
        workedFrom: '',
        hoursAmount: action.payload.value,
      };
      return {
        ...state,
        contributorsForm: {
          ...state.contributorsForm,
          [action.payload.contribId]: {
            ...state.contributorsForm[action.payload.contribId],
            technicians: techniciansValues,
          },
        },
      };

    case HANDLE_HOURS_AMOUNT_MORE_INFO:
      let techniciansValuesForMoreInfoHours = [
        ...state.contributorsForm[action.payload.contribId].technicians,
      ];
      let additionalInfoValues = [
        ...state.contributorsForm[action.payload.contribId].technicians[
          action.payload.techId
        ].additionalInfo,
      ];
      additionalInfoValues[action.payload.infoIndex] = {
        ...additionalInfoValues[action.payload.infoIndex],
        workedTo: '',
        workedFrom: '',
        hoursAmount: action.payload.value,
      };

      techniciansValuesForMoreInfoHours[action.payload.techId] = {
        ...state.contributorsForm[action.payload.contribId].technicians[
          action.payload.techId
        ],
        additionalInfo: additionalInfoValues,
      };
      return {
        ...state,
        contributorsForm: {
          ...state.contributorsForm,
          [action.payload.contribId]: {
            ...state.contributorsForm[action.payload.contribId],
            technicians: techniciansValuesForMoreInfoHours,
          },
        },
      };

    case HANDLE_DATE_MORE_INFO:
      let techniciansValuesForMoreInfoWorkedFrom = [
        ...state.contributorsForm[action.payload.contribId].technicians,
      ];
      let additionalInfoValuesWorkedFrom = [
        ...state.contributorsForm[action.payload.contribId].technicians[
          action.payload.techId
        ].additionalInfo,
      ];
      additionalInfoValuesWorkedFrom[action.payload.infoIndex] = {
        ...additionalInfoValuesWorkedFrom[action.payload.infoIndex],
        [action.payload.key]: action.payload.value,
        hoursAmount: '',
      };

      techniciansValuesForMoreInfoWorkedFrom[action.payload.techId] = {
        ...state.contributorsForm[action.payload.contribId].technicians[
          action.payload.techId
        ],
        additionalInfo: additionalInfoValuesWorkedFrom,
      };
      return {
        ...state,
        contributorsForm: {
          ...state.contributorsForm,
          [action.payload.contribId]: {
            ...state.contributorsForm[action.payload.contribId],
            technicians: techniciansValuesForMoreInfoWorkedFrom,
          },
        },
      };

    case HANDLE_ATTRIBUTE_CHANGE:
      return {
        ...state,
        contributorsForm: {
          ...state.contributorsForm,
          [action.payload.contribId]: {
            ...state.contributorsForm[action.payload.contribId],
            [action.payload.attribute]: action.payload.value,
          },
        },
      };

    case CLEAR_FORM:
      return {
        ...state,
        contributorsForm: {},
      };

    case SET_DAILY_REPORT_LOG_PDF:
      return {
        ...state,
        dailyReportLogPdf: action.payload,
      };

    case DELETE_DAILY_REPORT:
      return {
        ...state,
        dailyReports: state.dailyReports.filter(
          (report) => report.id !== action.payload
        ),
      };

    case SET_REPORT_PDF:
      return {
        ...state,
        reportLogPdf: action.payload,
      };

    case SET_REPORT_DATE:
      return {
        ...state,
        reportDate: action.payload,
      };

    case SET_REPORT_EXTRA_INPUTS:
      return {
        ...state,
        reportExtraInputs: action.payload,
      };

    case SET_REPORT_EXTRA_INPUT:
      return {
        ...state,
        reportExtraInputs: {
          ...state.reportExtraInputs,
          [action.payload.attribute]: action.payload.value,
        },
      };

    case SET_REPORT_OPEN_ITEM:
      return {
        ...state,
        reportOpenItem: action.payload,
      };

    case SET_REPORT_OPEN_ITEM_VALUE:
      return {
        ...state,
        reportOpenItem: {
          ...state.reportOpenItem,
          [action.payload.attribute]: action.payload.value,
        },
      };

    case SET_GENERAL_CONTACTOR_NAME:
      return {
        ...state,
        generalContactor: action.payload,
      };

    case SET_SUPERVISOR_TASKS:
      return {
        ...state,
        supervisorTasks: action.payload,
      };

    case SET_MEMBERS:
      return {
        ...state,
        members: action.payload,
      };

    case SET_DELETED_MEMBERS:
      return {
        ...state,
        deletedMembers: action.payload,
      };
    case SET_GCX_IMAGES:
      return {
        ...state,
        gcImages: action.payload,
      };
    case SET_GCX_DELETED_IMAGES:
      return {
        ...state,
        gcDeletedImages: action.payload,
      };

    case SUB_DAILY_REPORTS_COUNT_SUCCESS:
      return {
        ...state,
        subDailyReportsCount: action.payload,
      };

    case SUB_DAILY_REPORTS_COUNT_INIT:
      return {
        ...state,
        subDailyReportsCount: initialState.subDailyReportsCount,
      };

    case FIELD_WORK_ORDER_FORM_INIT:
      return {
        ...state,
        fieldWorkOrderForm: action.payload,
      };

    case FIELD_WORK_ORDER_FORM_ATTRIBUTE_SET:
      return {
        ...state,
        fieldWorkOrderForm: {
          ...state.fieldWorkOrderForm,
          [action.payload.attribute]: action.payload.value,
        },
      };

    case UPDATE_FIELD_WORK_ORDER_SUCCESS:
      return {
        ...state,
        currentFieldWorkOrder: action.payload,
        fieldWorkOrders: state.fieldWorkOrders.map((fwo) => {
          if (fwo.id === action.payload.id) {
            return action.payload;
          } else {
            return fwo;
          }
        }),
      };

    case DUPLICATE_DAILY_REPORT_SUCCESS:
      return {
        ...state,
        dailyReports: [
          action.payload,
          ...state.dailyReports.filter(
            (report) => report.id !== action.payload.id
          ),
        ],
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-daily-report-log/store/reducers.data.js